import { STDLblPos, SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import i18n from '@i18next/i18n';
import { ChartElementType } from '../Interface/chart-v3/chart-interaction.interface';
import type { IEGAxis } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import type { IChartAxis } from '../Interface/chart-v3/chart-properties.interface';


export enum GridlinesType {
    MAJOR_GRID = 'majorGridlines',
    MINOR_GRID = 'minorGridlines',
}

export const girdlinesTypeMapping = {
    [ChartElementType.MAJOR_GRID]: GridlinesType.MAJOR_GRID,
    [ChartElementType.MINOR_GRID]: GridlinesType.MINOR_GRID,
};

export const supportSubChartTypes = [
    SubChartType.AreaChart,
    SubChartType.Area3DChart,
    SubChartType.LineChart,
    SubChartType.Line3DChart,
    SubChartType.StockChart,
    SubChartType.RadarChart,
    SubChartType.ScatterChart,
    SubChartType.PieChart,
    SubChartType.Pie3DChart,
    SubChartType.DoughnutChart,
    SubChartType.BarChart,
    SubChartType.Bar3DChart,
    SubChartType.OfPieChart,
    SubChartType.BubbleChart,
];

export const AxisTypeMap: Record<keyof IEGAxis, IChartAxis['type']> = {
    catAx: 'category', // 分类坐标轴
    valAx: 'value', // 值坐标轴
    dateAx: 'date', // 日期坐标轴
    serAx: 'category', // todo 这个坐标轴还没有支持，先这么写
};

export enum LabelTextRunFieldType {
    SERIES_NAME = 'SERIESNAME',
    CATEGORY_NAME = 'CATEGORYNAME',
    VALUE = 'VALUE',
    PERCENTAGE = 'PERCENTAGE',
    BUBBLE_SIZE = 'BUBBLESIZE',
    X_VALUE = 'XVALUE',
    Y_VALUE = 'YVALUE',
    CELL_RANGE = 'CELLRANGE',
}

export const DataLabelPositionName = {
    [STDLblPos.outEnd]: i18n.t('数据标签外'),
    [STDLblPos.ctr]: i18n.t('居中'),
    [STDLblPos.b]: i18n.t('靠下'),
    [STDLblPos.inBase]: i18n.t('轴内侧'),
    [STDLblPos.inEnd]: i18n.t('数据标签内'),
    [STDLblPos.l]: i18n.t('靠左'),
    [STDLblPos.r]: i18n.t('靠右'),
    [STDLblPos.t]: i18n.t('靠上'),
    [STDLblPos.bestFit]: i18n.t('最佳匹配'),
};
